module.exports = __webpack_public_path__ + "img/class-disct-banner-jp.1ccb7d0.png";